<template>
  <div>
    <Card dis-hover title="车队充值核销">
      <!-- 统计卡片 -->
      <Row :gutter="16" style="margin-top: 5px;margin-bottom: 20px;">
        <Col span="8">
          <Card class="stat-card">
            <div class="stat-content">
              <div class="stat-icon amount-icon">
                <Icon type="ios-cash" size="30" />
              </div>
              <div class="stat-info">
                <div class="stat-label">总金额</div>
                <div class="stat-value highlight">¥{{ Number(totalData.total_amount || 0).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
              </div>
            </div>
          </Card>
        </Col>
        <Col span="8">
          <Card class="stat-card">
            <div class="stat-content">
              <div class="stat-icon count-icon">
                <Icon type="ios-time" size="30" />
              </div>
              <div class="stat-info">
                <div class="stat-label">待核销总金额</div>
                <div class="stat-value highlight">¥{{ Number(totalData.total_remain_amount || 0).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
              </div>
            </div>
          </Card>
        </Col>
        <Col span="8">
          <Card class="stat-card">
            <div class="stat-content">
              <div class="stat-icon company-icon">
                <Icon type="md-checkmark-circle" size="30" />
              </div>
              <div class="stat-info">
                <div class="stat-label">已核销金额</div>
                <div class="stat-value highlight">¥{{ Number(totalData.total_verify_amount || 0).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      <!-- 总计数据卡片 -->
      <Form ref="searchForm" :model="searchData" inline :label-width="70">
        <FormItem label="车队名称">
          <Input 
            v-model="searchData.company_name" 
            placeholder="请输入车队名称"
            clearable
            style="width: 180px"
          />
        </FormItem>
        <FormItem label="充值时间">
          <DatePicker 
            v-model="searchData.date_range" 
            type="datetimerange" 
            placement="bottom-end" 
            placeholder="选择日期范围（默认为近一周）"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 320px"
            @on-change="handleDateRangeChange"
          ></DatePicker>
        </FormItem>
        <FormItem label="是否核销">
          <Select v-model="searchData.payment_status" placeholder="是否核销">
            <Option value="">全部</Option>
            <Option value='0'>否</Option>
            <Option value='1'>是</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
          <Button @click="handleReset" style="margin-left: 10px">重置</Button>
          <Button type="success" icon="ios-download" @click="handleExport" :loading="exportLoading" style="margin-left: 10px">
            导出 Excel
          </Button>
          <Button type="primary" icon="md-add" @click="showAddDrawer = true" style="margin-left: 10px">
            添加
          </Button>
        </FormItem>
      </Form>
    </Card>



    <Card style="margin-top: 20px;">
      <Table 
        :columns="tableColumn" 
        :data="tableData"
        :loading="loading"
        border
      ></Table>
      
      <Page 
        class="page"
        :total="total"
        :current="currentPage"
        :page-size="pageSize"
        show-total
        show-elevator
        show-sizer
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSizeChange"
        @on-prev="handlePageChange"
        @on-next="handlePageChange"
      ></Page>
    </Card>

    <!-- 添加充值记录抽屉 -->
    <Modal v-model="showAddDrawer" title="添加充值记录" width="550" :mask-closable="true" @on-cancel="cancelAdd">
      <Form ref="addForm" :model="addForm" :label-width="100">
        <FormItem label="车队" prop="company_id">
          <Select v-model="addForm.company_id" placeholder="请选择车队" filterable>
            <Option v-for="item in companys" :key="item.company_id" :value="item.company_id">{{ item.company_name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="充值金额" prop="amount">
          <Input v-model="addForm.amount" placeholder="请输入充值金额" />
        </FormItem>
        <FormItem label="充值时间" prop="recharge_time">
          <DatePicker
            v-model="addForm.recharge_time"
            type="datetime"
            placeholder="请选择充值时间"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem label="是否已核销" prop="payment_status">
          <Select v-model="addForm.payment_status" placeholder="请选择核销状态">
            <Option :value="0">否</Option>
            <Option :value="1">是</Option>
          </Select>
        </FormItem>
        <FormItem label="核销时间" prop="payment_time" v-if="addForm.payment_status === 1">
          <DatePicker
            v-model="addForm.payment_time"
            type="datetime"
            placeholder="请选择核销时间"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem label="核销备注" prop="manual_remark">
          <Input v-model="addForm.manual_remark" type="textarea" :rows="3" placeholder="请输入备注（选填）" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelAdd">取消</Button>
        <Button type="primary" :loading="addLoading" @click="handleAdd">确定</Button>
      </div>
    </Modal>

    <!-- 核销记录弹窗 -->
    <Modal v-model="showVerifyModal" title="核销流水记录" width="900" :mask-closable="true">
      <Table 
        :columns="verifyRecordColumns" 
        :data="verifyRecords"
        :loading="verifyRecordLoading"
        border
        stripe
      ></Table>
    </Modal>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  name: "companyRechargeTotal",
  data() {
    return {
      searchData: {
        company_name: '', // 车队名称
        date_range: [], // 默认今天
        payment_status: '0' //是否核销，默认为否
      },
      totalData: {},
      tableData: [],
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      detailModal: {
        show: false,
        data: null
      },
      detailData: [],
      detailLoading: false,
      detailTotal: 0,
      detailCurrentPage: 1,
      detailPageSize: 100,
      detailMaxHeight: 500,
      exportLoading: false,
      showAddDrawer: false,
      addLoading: false,
      companys: [],
      addForm: {
        company_id: '',
        amount: '',
        recharge_time: '',
        payment_status: 0,
        payment_time: '',
        manual_remark: ''
      },
      // 核销记录弹窗
      showVerifyModal: false,
      verifyRecords: [],
      verifyRecordLoading: false,
      currentRechargeId: null,
      verifyRecordColumns: [
        { title: 'ID', key: 'id', align: 'center', width: 80 },
        { title: '核销金额', key: 'amount', align: 'center', width: 120, render: (h, params) => {
          return h('span', { style: { color: '#19be6b', fontWeight: 'bold' } }, `¥${params.row.amount || '0.00'}`)
        }},
        { title: '备注', key: 'remark', align: 'center', minWidth: 150 },
        { title: '操作人', key: 'operator_name', align: 'center', width: 120 },
        { title: '核销时间', key: 'create_time', align: 'center', width: 180 }
      ],
      tableColumn: [
        {
          title: '记录ID',
          key: 'id',
          align: 'center',
          width: 80
        },
        {
          title: '车队 ID',
          key: 'company_id',
          align: 'center',
          width: 70
        },
        {
          title: '车队名称',
          key: 'company_name',
          align: 'center',
          minWidth: 140,
          ellipsis: true
        },
        {
          title: '充值金额',
          key: 'amount',
          align: 'center',
          width: 120,
          render: (h, params) => {
            return h('span', {
              style: { color: '#19be6b', fontWeight: 'bold' }
            }, `¥${params.row.amount || '0.00'}`)
          }
        },
        {
          title: '已核销金额',
          key: 'paid_amount',
          align: 'center',
          width: 100,
          render: (h, params) => {
            const paid = parseFloat(params.row.paid_amount) || 0
            return h('span', {
              style: { color: '#ed4014' }
            }, `¥${paid.toFixed(2)}`)
          }
        },
        {
          title: '剩余金额',
          key: 'remain_amount',
          align: 'center',
          width: 100,
          render: (h, params) => {
            // 剩余金额 = 充值金额 - 已核销金额
            const remain = this.getRemainAmount(params.row)
            return h('span', {
              style: { color: '#2d8cf0', fontWeight: 'bold' }
            }, `¥${remain.toFixed(2)}`)
          }
        },
        {
          title: '充值时间',
          key: 'recharge_time',
          align: 'center',
          minWidth: 140,
          ellipsis: true
        },
        {
          title: '是否已核销',
          key: 'payment_status_name',
          align: 'center',
          width: 80
        },
        {
          title: '核销时间',
          key: 'payment_time',
          align: 'center',
          minWidth: 140,
          ellipsis: true
        },
        {
          title: '核销备注',
          key: 'manual_remark',
          align: 'center',
          minWidth: 120,
          ellipsis: true
        },
        {
          title: '操作人',
          key: 'operator_name',
          align: 'center',
          minWidth: 100,
          ellipsis: true
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 160,
          render: (h, params) => {
            const row = params.row
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.showVerifyRecords(row)
                  }
                }
              }, '查看'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.markAsPaid(row)
                  }
                }
              }, '核销')
            ])
          }
        }
      ]
    }
  },
  methods: {
    async getTotalData() {
      this.loading = true
      try {
        let params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        
        // 添加车队名称参数
        if (this.searchData.company_name) {
          params.company_name = this.searchData.company_name.trim()
        }
        // 添加是否核销参数
        if (this.searchData.payment_status) {
          params.payment_status = this.searchData.payment_status
        }

        if (this.searchData.date_range && Array.isArray(this.searchData.date_range)
            && this.searchData.date_range.length === 2 && this.searchData.date_range[0] !== '') {
          // 格式化日期对象为字符串
          const startDate = this.searchData.date_range[0]
          const endDate = this.searchData.date_range[1]
          
          // 开始时间：设置为当天的 00:00:00
          const start = new Date(startDate)
          start.setHours(0, 0, 0, 0)
          params.start_date = this.formatDateToString(start)
          
          // 结束时间：强制设置为当天的 23:59:59
          const end = new Date(endDate)
          end.setHours(23, 59, 59, 999)
          params.end_date = this.formatDateToString(end)
        }

        // 调用列表接口获取车队明细数据
        let listRes = await this.$commonFun.postProxy('admin/finance/getUnpaidRechargeList', params)
        this.$commonFun.dealApiResult(listRes, () => {
          this.tableData = listRes.data || []
          this.total = listRes.count || 0
          this.totalData = listRes.extra || 0
        })
      } catch (error) {
        console.error('获取充值汇总数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    handleSearch() {
      this.currentPage = 1
      this.getTotalData()
    },
    
    handleReset() {
      this.searchData.company_name = ''
      this.searchData.date_range = this.getTodayRange()
      this.currentPage = 1
      this.getTotalData()
    },
    
    handleDateRangeChange(dates) {
      // 当用户选择日期范围后，强制修正结束时间为 23:59:59
      if (dates && dates.length === 2) {
        const endDate = new Date(dates[1])
        endDate.setHours(23, 59, 59, 999)
        this.searchData.date_range = [dates[0], endDate]
      }
    },
    
    handlePageChange(page) {
      this.currentPage = page
      this.getTotalData()
    },
    
    handlePageSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.getTotalData()
    },
    markAsPaid(row) {
      let remark = '' // 存放备注内容
      let verify_amount = null // 存放本次核销金额
      const remainAmount = this.getRemainAmount(row)

      this.$Modal.confirm({
        title: '核销',
        content: '请输入核销金额',
        type: 'warning',
        render: (h) => {
          return h('div', [
            h('p', {
              style: { marginBottom: '4px', fontSize: '14px' }
            }, `充值金额：¥${row.amount || '0.00'}，可核销金额：¥${remainAmount.toFixed(2)}`),
            h('Input', {
              props: {
                placeholder: '请输入本次核销金额',
                value: verify_amount,
                type: 'number'
              },
              on: {
                input: (val) => {
                  verify_amount = val
                }
              },
              style: {
                marginTop: '10px',
                width: '100%'
              }
            }),
            h('Input', {
              props: {
                placeholder: '请输入备注（选填）',
                value: remark
              },
              on: {
                input: (val) => {
                  remark = val
                }
              },
              style: {
                marginTop: '10px'
              }
            })
          ])
        },
        confirmText: '确定',
        cancelText: '取消',
        onOk: async () => {
          if (!verify_amount) {
            this.$Message.warning('请输入核销金额')
            return Promise.reject() // 阻止关闭弹窗
          }
          if (parseFloat(verify_amount) > remainAmount) {
            this.$Message.warning('核销金额不能大于可核销金额')
            return Promise.reject() // 阻止关闭弹窗
          }

          const res = await this.$commonFun.postProxy('admin/finance/markAsPaid', {
            id: row.id,
            verify_amount: parseFloat(verify_amount),
            remark: remark // 传给后端
          })
          this.$commonFun.dealApiResult(res, () => {
            this.$commonFun.successTip(res.msg)
            this.getTotalData()
          })
        }
      })
    },
    // 计算剩余可核销金额
    getRemainAmount(row) {
      if (!row) return 0
      // 优先使用后端返回的剩余金额字段（如有）
      if (row.remain_amount !== undefined && row.remain_amount !== null) return parseFloat(row.remain_amount) || 0
      if (row.unpaid_amount !== undefined && row.unpaid_amount !== null) return parseFloat(row.unpaid_amount) || 0
      // 通过已核销金额换算剩余金额
      if (row.paid_amount !== undefined && row.paid_amount !== null) {
        return (parseFloat(row.amount) || 0) - (parseFloat(row.paid_amount) || 0)
      }
      return parseFloat(row.amount) || 0
    },


    async handleExport() {
      this.exportLoading = true
      try {
        // 准备请求参数
        let params = {
          page: 1,
          page_size: 10000 // 获取所有数据
        }
        
        // 添加车队名称参数
        if (this.searchData.company_name) {
          params.company_name = this.searchData.company_name.trim()
        }
        
        // 添加时间范围参数
        if (this.searchData.date_range && Array.isArray(this.searchData.date_range)
            && this.searchData.date_range.length === 2 && this.searchData.date_range[0] !== '') {
          const startDate = this.searchData.date_range[0]
          const endDate = this.searchData.date_range[1]
          
          // 开始时间：设置为当天的 00:00:00
          const start = new Date(startDate)
          start.setHours(0, 0, 0, 0)
          params.start_date = this.formatDateToString(start)
          
          // 结束时间：强制设置为当天的 23:59:59
          const end = new Date(endDate)
          end.setHours(23, 59, 59, 999)
          params.end_date = this.formatDateToString(end)
        }
        
        // 调用导出接口
        const exportRes = await this.$commonFun.postProxy('admin/finance/exportUnpaidRecharge', params)
        if (exportRes.code === 200 && exportRes.data && exportRes.data.length > 0) {
          // 直接使用后端返回的数据，不做过滤
          const exportData = exportRes.data
          // 使用 XLSX 库生成 Excel
          const worksheet = XLSX.utils.aoa_to_sheet(exportData)
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, '充值核销明细')
          
          // 根据实际列数设置列宽（单位：字符数）
          const colCount = exportData[0] ? exportData[0].length : 0
          const wscols = []
          for (let i = 0; i < colCount; i++) {
            wscols.push({ wch: 20 }) // 默认每列宽度20
          }
          worksheet['!cols'] = wscols
          
          // 生成文件名
          const fileName = `充值核销明细_${this.formatDateForFilename(new Date())}.xlsx`
          
          // 下载文件
          XLSX.writeFile(workbook, fileName)
          
          this.$Message.success('导出成功')
        } else {
          this.$Message.error('暂无数据可导出')
        }
      } catch (error) {
        console.error('导出失败:', error)
        this.$Message.error('导出失败，请稍后重试')
      } finally {
        this.exportLoading = false
      }
    },
    formatDateForFilename(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}${month}${day}${hours}${minutes}${seconds}`
    },
    formatDateToString(date) {
      if (!date) return ''
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return dateStr.replace(/ /g, '<br>')
    },
    formatDateTime(date, isEndDate = false) {
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = isEndDate ? '23' : String(d.getHours()).padStart(2, '0')
      const minutes = isEndDate ? '59' : String(d.getMinutes()).padStart(2, '0')
      const seconds = isEndDate ? '59' : String(d.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    cancelAdd() {
      this.showAddDrawer = false
      this.addForm = { company_id: '', amount: '', recharge_time: '', payment_status: 0, payment_time: '', manual_remark: '' }
    },
    async handleAdd() {
      if (!this.addForm.company_id) {
        return this.$Message.warning('请选择车队')
      }
      if (!this.addForm.amount || parseFloat(this.addForm.amount) <= 0) {
        return this.$Message.warning('请输入有效的充值金额')
      }
      if (!this.addForm.recharge_time) {
        return this.$Message.warning('请选择充值时间')
      }
      if (this.addForm.payment_status === 1 && !this.addForm.payment_time) {
        return this.$Message.warning('请选择核销时间')
      }
      this.addLoading = true
      try {
        let params = {
          company_id: this.addForm.company_id,
          amount: this.addForm.amount,
          recharge_time: this.formatDateToString(new Date(this.addForm.recharge_time)),
          payment_status: this.addForm.payment_status,
          payment_time: this.addForm.payment_status === 1 && this.addForm.payment_time
            ? this.formatDateToString(new Date(this.addForm.payment_time))
            : '',
          manual_remark: this.addForm.manual_remark
        }
        let res = await this.$commonFun.postProxy('admin/finance/addRechargeRecord', params)
        this.$commonFun.dealApiResult(res, () => {
          this.$Message.success(res.msg || '添加成功')
          this.cancelAdd()
          this.getTotalData()
        })
      } catch (error) {
        console.error('添加充值记录失败:', error)
        this.$Message.error('添加失败，请稍后重试')
      } finally {
        this.addLoading = false
      }
    },
    getTodayRange() {
      const today = new Date()
      const startOfDay = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate(), 0, 0, 0)
      const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      return [startOfDay, endOfDay]
    },
    // 查看核销流水记录
    async showVerifyRecords(row) {
      this.currentRechargeId = row.id
      this.showVerifyModal = true
      this.verifyRecordLoading = true
      try {
        const res = await this.$commonFun.postProxy('admin/finance/getVerifyRecordList', { recharge_id: row.id })
        if (res.code === 200) {
          this.verifyRecords = res.data || []
        } else {
          this.$Message.error(res.msg || '获取核销记录失败')
        }
      } catch (error) {
        console.error('获取核销记录失败:', error)
        this.$Message.error('获取核销记录失败')
      } finally {
        this.verifyRecordLoading = false
      }
    }
  },
  mounted() {
    // 设置默认一年时间范围为今天 00:00:00 到 23:59:59
    this.searchData.date_range = this.getTodayRange()
    this.getTotalData()
    // 加载车队列表
    this.$commonFun.postProxy('admin/common/getPageInitInfo', {'type':'companys'}).then((res) => {
      if (res.code === 200 && res.data && res.data.companys) {
        this.companys = res.data.companys.map(item => ({
          company_id: item.id,
          company_name: item.name
        }))
      }
    })
  }
}
</script>

<style scoped lang="less">
.page {
  position: relative;
  margin-top: 20px;
  left: 0;
  text-align: right;
}

.stat-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }
  
  .ivu-card-body {
    padding: 24px;
  }
}

.stat-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stat-icon {
  width: 70px;
  height: 70px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &.amount-icon {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #fff;
  }
  
  &.count-icon {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: #fff;
  }
  
  &.company-icon {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    color: #fff;
  }
}

.stat-info {
  flex: 1;
  margin-left: 20px;
}

.stat-label {
  font-size: 14px;
  color: #808695;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #17233d;
  line-height: 1;
  
  &.highlight {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

.detail-header {
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 6px;
}

.header-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .header-label {
    width: 100px;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
  }
  
  .header-value {
    flex: 1;
    color: #17233d;
    font-size: 14px;
    
    &.highlight {
      color: #19be6b;
      font-weight: bold;
      font-size: 18px;
    }
  }
}

.drawer-footer {
  margin-top: 20px;
  text-align: right;
  padding-top: 16px;
  border-top: 1px solid #e8eaec;
}

.detail-content {
  padding: 10px 0;
}

.detail-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 4px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .detail-label {
    width: 100px;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
  }
  
  .detail-value {
    flex: 1;
    color: #17233d;
    font-size: 14px;
    
    &.highlight {
      color: #19be6b;
      font-weight: bold;
      font-size: 18px;
    }
  }
}

.data-card {
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }
  
  p[slot="title"] {
    font-size: 14px;
    color: #808695;
    margin-bottom: 10px;
  }
  
  .data-value {
    font-size: 28px;
    font-weight: bold;
    color: #17233d;
    line-height: 1.5;
    
    &.highlight {
      color: #19be6b;
    }
    
    &.warning {
      color: #ff9900;
    }
  }
}
</style>
